import { supabase } from '@/lib/supabase';
import type { PublicProspectPreview } from '@/types';

export async function publicPreviewRequest(token: string): Promise<PublicProspectPreview> {
  const { data, error } = await supabase.functions.invoke('admin-api', {
    body: { action: 'prospect-preview-public', input: { token } },
  });
  if (error) throw new Error(error.message);
  if (data?.error) throw new Error(String(data.error));
  return data?.data as PublicProspectPreview;
}
